export const AMSTERDAM_TIME_ZONE = "Europe/Amsterdam";

function dateParts(value) {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: AMSTERDAM_TIME_ZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
    }).formatToParts(date);
    return Object.fromEntries(parts.filter(({ type }) => type !== "literal").map(({ type, value: partValue }) => [type, partValue]));
}

export function formatAmsterdamDateTime(value) {
    const parts = dateParts(value);
    if (!parts) return { date: "", time: "" };
    return { date: `${parts.day}-${parts.month}-${parts.year}`, time: `${parts.hour}:${parts.minute}` };
}

export function formatAmsterdamFriendlyDateTime(value) {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("nl-NL", {
        timeZone: AMSTERDAM_TIME_ZONE,
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
    }).format(date);
}

export function amsterdamDayKey(value = new Date()) {
    const parts = dateParts(value);
    return parts ? `${parts.year}-${parts.month}-${parts.day}` : null;
}

export function isSameAmsterdamDay(first, second = new Date()) {
    return amsterdamDayKey(first) === amsterdamDayKey(second);
}

export function amsterdamToday() {
    const parts = dateParts(new Date());
    return new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
}

export function validateAmsterdamDateInput(value) {
    if (value === null || value === undefined || value === "" || value === "0") {
        return null;
    }

    if (!/^\d{2}-\d{2}-\d{4}$/.test(value)) {
        return "Gebruik de datumnotatie DD-MM-JJJJ.";
    }

    const [day, month, year] = value.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return "Vul een geldige datum in.";
    }

    const today = amsterdamToday();
    const maximum = new Date(today);
    maximum.setFullYear(maximum.getFullYear() + 3);
    if (date < today) {
        return "Een datum in het verleden kan niet worden ingevoerd.";
    }
    if (date > maximum) {
        return "Een datum mag maximaal drie jaar vooruit liggen.";
    }

    return null;
}

export function dateValueToPicker(value) {
    if (!/^\d{2}-\d{2}-\d{4}$/.test(String(value || ""))) return "";
    const [day, month, year] = value.split("-");
    return `${year}-${month}-${day}`;
}

export function pickerValueToDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
    const [year, month, day] = value.split("-");
    return `${day}-${month}-${year}`;
}

export function amsterdamDatePickerBounds() {
    const today = amsterdamToday();
    const maximum = new Date(today);
    maximum.setFullYear(maximum.getFullYear() + 3);
    const toPickerValue = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    return { min: toPickerValue(today), max: toPickerValue(maximum) };
}
